export default {
  get_answers: ({ answers_user }) => answers_user
};
